/*ハンバーガーメニューをクリックでFV-TOPナビを開閉*/
document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.wp-block-lazyblock-hamburger');
    const buttonHamburger = document.querySelector('button.hamburger');
    const nav = document.querySelector('.fv-top__nav');

    if (!hamburger || !nav) return;

    hamburger.addEventListener('click', () => {
        buttonHamburger.classList.toggle('is-open');
        nav.classList.toggle('is-open');
    });
});

/*ハンバーガーメニューをクリックでFVナビを開閉*/
document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.wp-block-lazyblock-hamburger');
    const buttonHamburger = document.querySelector('button.hamburger');
    const nav = document.querySelector('.fv__nav');

    if (!hamburger || !nav) return;

    hamburger.addEventListener('click', () => {
        buttonHamburger.classList.toggle('is-open');
        nav.classList.toggle('is-open');
    });
});

/* 画面幅変更時にドロワーメニューを閉じる */
window.addEventListener('resize', () => {
    const buttonHamburger = document.querySelector('button.hamburger');
    const navTop = document.querySelector('.fv-top__nav');
    const nav = document.querySelector('.fv__nav');

    if (buttonHamburger) {
        buttonHamburger.classList.remove('is-open');
    }

    if (navTop) {
        navTop.classList.remove('is-open');
    }

    if (nav) {
        nav.classList.remove('is-open');
    }
});

/*トップへ戻るボタン スクロールで戻る*/
document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('.to-top');
    if (!btn) return;

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

/*トップへ戻るボタン スクロールで表示*/
document.addEventListener('DOMContentLoaded', () => {
    const toTop = document.querySelector('.to-top');
    if (!toTop) return;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
            toTop.classList.add('is-show');
        } else {
            toTop.classList.remove('is-show');
        }
    });
});
